import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const DesignProjectSeparator = () => {
  return (
    <div className="h-screen w-full flex flex-col md:flex-row overflow-hidden">
      {/* Section Bureau d'étude */}
      <Link to="/design-office" className="relative w-full md:w-1/2 h-1/2 md:h-screen group">
        <motion.div 
          className="w-full h-full bg-cocoa flex items-center justify-center overflow-hidden"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        >
          {/* <div className="absolute inset-0 bg-black/40 z-10"/> */}
          <img
            src="/assets/images/separateur-design-project/BUREAU D'ETUDE.jpeg"
            alt="Bureau d'étude"
            className="absolute w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
          <motion.h2 
            className="text-4xl md:text-6xl lg:text-8xl font-light text-cream z-20 text-center font-cormorant"
            whileHover={{ scale: 1.1 }}
          >
            Bureau d'étude
          </motion.h2>
        </motion.div>
      </Link>

      {/* Section Nos réalisations */}
      <Link to="/design-and-projects" className="relative w-full md:w-1/2 h-1/2 md:h-screen group">
        <motion.div 
          className="w-full h-full bg-cream flex items-center justify-center overflow-hidden"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        >
          {/* <div className="absolute inset-0 bg-black/40 z-10"/> */}
          <img
            src="/assets/images/separateur-design-project/NOS REALISATIONS.jpeg"
            alt="Nos réalisations"
            className="absolute w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
          <motion.h2 
            className="text-4xl md:text-6xl lg:text-8xl font-light text-cream z-20 text-center font-cormorant"
            whileHover={{ scale: 1.1 }}
          >
            Nos réalisations
          </motion.h2>
        </motion.div>
      </Link>
    </div>
  );
};

export default DesignProjectSeparator;